// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addToJSON(target: any) {
	target.prototype.toJSON = function () {
		// start with an empty object (see other alternatives below)
		const jsonObj = Object.assign({}, this)

		// add all properties
		const proto = Object.getPrototypeOf(this)
		for (const key of Object.getOwnPropertyNames(proto)) {
			const desc = Object.getOwnPropertyDescriptor(proto, key)
			const hasGetter = desc && typeof desc.get === 'function'
			if (hasGetter) {
				jsonObj[key] = this[key]
			}
		}
		// for (const i in jsonObj) {
		// 	const value = jsonObj[i]
		// 	if (typeof value === 'object' && value.constructor) {
		// 		jsonObj[i] = value.toJSON()
		// 	}
		// }
		return jsonObj
	}
}
